import { Component, OnInit } from '@angular/core';
import { CAISAuditTrailComponent } from '../cais-audit-trail/cais-audit-trail.component';
@Component({
    selector: 'app-cais-audit-trail-details',
    imports: [CAISAuditTrailComponent],
    template: `<div class="col-md-12 nopadding">
              <app-cais-audit-trail 
                [showFilter]="true"
                [staticFilter]="false">
              </app-cais-audit-trail>
            </div>`
})

export class CAISAuditTrailDetailsComponent implements OnInit {

  constructor() {
    
  }

  ngOnInit() {
    
  }

}